"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider, { type Settings } from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-skin-01.svg" | "/Templates/Doccure/img/company/company-skin-02.svg" | "/Templates/Doccure/img/company/company-skin-03.svg" | "/Templates/Doccure/img/company/company-skin-04.svg" | "/Templates/Doccure/img/company/company-skin-05.svg" | "/Templates/Doccure/img/company/company-skin-06.svg" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "client logo" */
    alt?: string;
};

type AboutSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Experienced Dermatology Specialists" | "Modern Technology & Advanced Treatments" | "Personalized Skin Care Plans" | "Safe & Comfortable Environment" | "Transparent & Ethical Care" */
    p0Text: ReactNode;
};
const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeFourteenAboutSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-06.jpg" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-07.jpg" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "15+" */
    sectionDiv0Div0Div0Div0Div2P0PText?: ReactNode;
    /** Default: "Years of" */
    sectionDiv0Div0Div0Div0Div2P1PText?: ReactNode;
    /** Default: "Experience" */
    sectionDiv0Div0Div0Div0Div2P1Span0SpanText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "Expertise," */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Trusted" */
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Personal Care" */
    sectionDiv0Div0Div1Div0Div0H20Span1SpanText?: ReactNode;
    /** Default: "Your skin deserves expert care, compassion, and confidence. At our dermatology clinic, we are dedicated to providing advanced, personalized skin, hair, and nail treatments for patients." */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "video" */
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/video-02.jpg" */
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "video" */
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkAriaLabel?: string;
    /** Default: "" */
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkDataFancybox?: string;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkHref?: string;
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv1Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    aboutSectionSlides: AboutSectionSlidesItem[];
    aboutSectionUls: AboutSectionUlsItem[];
    aboutSectionSlidesItemWrapper?: (item: AboutSectionSlidesItem, content: ReactNode) => ReactNode;
    aboutSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionSlidesImageVisible?: boolean;
    aboutSectionSlidesImageRenderer?: (item: AboutSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSectionUlsItemWrapper?: (item: AboutSectionUlsItem, content: ReactNode) => ReactNode;
    aboutSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeFourteenAboutSectionGenerated: FC<HomeFourteenAboutSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-06.jpg",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-07.jpg",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Div2P0PText = "15+",
    sectionDiv0Div0Div0Div0Div2P1PText = "Years of",
    sectionDiv0Div0Div0Div0Div2P1Span0SpanText = "Experience",
    sectionDiv0Div0Div1Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0Div0H20H2Text = "Expertise,",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText = "Trusted",
    sectionDiv0Div0Div1Div0Div0H20Span1SpanText = "Personal Care",
    sectionDiv0Div0Div1Div0Div0P0PText = "Your skin deserves expert care, compassion, and confidence. At our dermatology clinic, we are dedicated to providing advanced, personalized skin, hair, and nail treatments for patients.",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt = "video",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/video-02.jpg",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkAriaLabel = "video",
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkDataFancybox = "",
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkHref = "#",
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkVisible,
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkRenderer,
    sectionDiv0Div0Div1Div0Div1Div0Link0LinkProps,
    divImageWithBasePath0ImageProps,
    sectionDiv1Slider0SliderProps,
    sectionDiv0Div0ClassName,
    aboutSectionSlides,
    aboutSectionUls,
    aboutSectionSlidesItemWrapper,
    aboutSectionSlidesRenderer,
    aboutSectionSlidesImageVisible,
    aboutSectionSlidesImageRenderer,
    aboutSectionSlidesImageProps,
    aboutSectionUlsItemWrapper,
    aboutSectionUlsRenderer,
}) => {
    return (
        <>
            <section className="about-section-fourteen section pb-0">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-5">
                            <div className="about-img-fourteen">
                                <div className="about-img-01">
                                    {renderNode(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div className="about-img-02">
                                    {renderNode(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div className="exp-item">
                                    <p className="num mb-0">{sectionDiv0Div0Div0Div0Div2P0PText}</p>
                                    <p className="mb-0">
                                        {sectionDiv0Div0Div0Div0Div2P1PText}
                                        <span>{sectionDiv0Div0Div0Div0Div2P1Span0SpanText}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about-content-fourteen">
                                <div className="section-header section-header-fourteen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0Div0DivDataWowDuration}>
                                    {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                            <span className="section-line">{sectionDiv0Div0Div1Div0Div0H20Span0SpanText}</span>
                                            {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                            {" "}
                                            <span className="subtitle">{sectionDiv0Div0Div1Div0Div0H20Span1SpanText}</span>
                                        </h2>
                                    ))}
                                    <p className="mb-0">{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                                </div>
                                <div className="about-wrap">
                                    <ul className="about-lists">
                                        {renderCollectionNode(
                                            aboutSectionUls,
                                            (item: AboutSectionUlsItem) => (
                                                <li key={item.key}>
                                                    <p>{item.p0Text}</p>
                                                </li>
                                            ),
                                            aboutSectionUlsItemWrapper,
                                            aboutSectionUlsRenderer
                                        )}
                                    </ul>
                                    <div className="abt-video">
                                        {renderNode(sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                        {renderNode(sectionDiv0Div0Div1Div0Div1Div0Link0LinkVisible, sectionDiv0Div0Div1Div0Div1Div0Link0LinkRenderer, (
                                            <SmartLink href={sectionDiv0Div0Div1Div0Div1Div0Link0LinkHref} className="video-icon" aria-label={sectionDiv0Div0Div1Div0Div1Div0Link0LinkAriaLabel} data-fancybox={sectionDiv0Div0Div1Div0Div1Div0Link0LinkDataFancybox} {...(sectionDiv0Div0Div1Div0Div1Div0Link0LinkProps ?? {})}>
                                                <i className="isax isax-arrow-right-41" />
                                            </SmartLink>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="company-slider-fourteen section-top">
                    <Slider {...settings} {...(sectionDiv1Slider0SliderProps ?? {})}>
                        {renderCollectionNode(
                            aboutSectionSlides,
                            (item: AboutSectionSlidesItem) => (
                                <div className={item.className ?? "slide-item"} key={item.key}>
                                    {renderItemNode(aboutSectionSlidesImageVisible, aboutSectionSlidesImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "client logo"} {...(typeof aboutSectionSlidesImageProps === "function" ? aboutSectionSlidesImageProps(item) : (aboutSectionSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            ),
                            aboutSectionSlidesItemWrapper,
                            aboutSectionSlidesRenderer
                        )}
                    </Slider>
                </div>
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeFourteenAboutSectionGenerated;
